module.exports = __webpack_public_path__ + "static/media/client-indonesiax.e3f79ae6.png";